import {
  type DataReportClient,
  type DebtorDataReport,
  type RiskMatrixState,
} from './types';

const initialDataReportClient: DataReportClient = {
  vehicles: undefined,
  realStates: undefined,
  dicom: undefined,
  sbif: undefined,
  tgrReport: undefined,
  shareHolders: undefined,
  salesMonthly: undefined,
  purchasesMonthly: undefined,
  summaryReport: undefined,
  courtCases: undefined,
};

const initialDebtorDataReport: DebtorDataReport = {
  vehicles: undefined,
  dicom: undefined,
  sbif: undefined,
  realStates: undefined,
  courtCases: undefined,
};

const initialFilters: RiskMatrixState = {
  client: {
    report: initialDataReportClient,
  },
  debtor: {
    report: initialDebtorDataReport,
  },
};

export { initialDataReportClient, initialFilters };
